import React from "react";
import { connectionModeImage } from "../../config/constants/ConnectionMode";
import { FormattedMessage } from "react-intl";
import "./LuxTrustFrameTop.less";

export class LuxTrustFrameTop extends React.Component {

  handleChangeConnection = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onChangeConnection();
  };

  render() {
    const { mode } = this.props;
    const { src, srcSet } = connectionModeImage[mode] || {};
    return (
      <div className="luxtrust-iframe-top">
        <img
          src={src}
          srcSet={srcSet}
          className="luxtrust-iframe-top__device-image"
          alt="luxtrust"
        />
        <div className="luxtrust-iframe-top__text-container">
          <div>
            <FormattedMessage
              id="iframe.i-connect-as"
              tagName="h1"
              values={{
                mode: (
                  <strong>
                    <FormattedMessage id={`connection-mode.${mode}`} />
                  </strong>
                )
              }}
            />
          </div>
          <div className="luxtrust-iframe-top__change-link">
            <div onClick={this.handleChangeConnection}>
              <span className={'change-mode-link'}>
                <FormattedMessage id="iframe.click-to-change-connection" />
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
